import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import DataType from '../../../../../Types/DataTablePiclist';
import Utilisateur from '../../../../../Models/Utilisateur';
import Params from '../../../../../Types/ParamsPicklist';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';
import Datas from '../../../../../Data/Data.json';

let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchOperat: Params = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

function Tab3(props: { form?: any }) {
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const authHeader = useAuthHeader()
  const [Data, SetData] = useState<DataType[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [pageIsLoad, setPageIsLoad] = useState(true)

  if (pageIsLoad) {
    setPageIsLoad(false)
    setLoading(true);
    const datat: DataType[] = [];
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(searchPlanCpte))
      }
    };
    axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            if (datas.length === 0) {
              SetData(datat)
            }
            else {
              datas.map((data: any, indice: number) => {
                datat.push({ key: indice, Code: data[Object.keys(data)[1]], Libelle: data[Object.keys(data)[0]], });
                SetData(datat);
              })
            }
          }
        }
        setLoading(false);
      }).catch((error) => {
        console.log(error)
        setLoading(false);
      })
  }

  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Grid item xs={12} md={12}  lg={12} >
            <SelectMultipleOptionPanier notRequired disabled form={props.form}  Size="large"  width={4}  label="Frais de gestion"  name="CodeFrais"  Parametre={searchOperat} />
          </Grid>
        </Box>
      </div>
    </div>
  )
}

export default Tab3;
